module.exports = __webpack_public_path__ + "img/day-evening-night.de5c700c.svg";